import { useEffect, useMemo } from 'react';
import { Form, Field } from 'react-final-form';
import { InputLabel, MenuItem, Select, FormControl, Box } from '@mui/material';
import { useTranslation } from 'core/contexts/localization';

const Item = ({ language, resources }) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '8px' }}>
            <img src={resources[language].image} width="16px" height="16px" alt={`${resources[language]}`} />
            <p style={{ margin: 0 }}>{language.toUpperCase()}</p>
        </div>
    );
};

const LanguageInputs = () => {
    const { i18n, t: translate } = useTranslation();
    const locales = useMemo(() => Object.keys(i18n.options.resources), [i18n.options.resources]);

    const handleChange = (input) => {
        i18n.changeLanguage(input);
    };

    useEffect(() => {
        try {
            window.localStorage.setItem('i18nextLng', i18n.language);
        } catch (e) {
            //ignore
        }
    }, [i18n.language]);

    return (
        <>
            <FormControl variant="outlined">
                <InputLabel id="select-language" style={{ fontWeight: 'bold' }}>
                    {translate('layout.language')}
                </InputLabel>
                <Select sx={{ backgroundColor: 'rgba(255, 255, 255, 0.2)' }} labelId="select-language" id="select-language" label={translate('layout.language')} variant="outlined" defaultValue={i18n.language} value={i18n.language} onChange={(e) => handleChange(e.target.value)}>
                    {locales.map((value) => {
                        return (
                            <MenuItem key={`language-${value}`} style={{ color: 'black' }} value={value}>
                                <Item language={value} resources={i18n.options.resources} />
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        </>
    );
};

const LanguageDropDown = (className) => {
    const handleSubmit = () => {};
    return (
        <Box>
            <Form
                className={className}
                onSubmit={handleSubmit}
                render={({ handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <Field autoFocus name={'LanguageDropDown'} component={LanguageInputs} />
                    </form>
                )}
            />
        </Box>
    );
};

export default LanguageDropDown;
